import { useHistory } from "react-router-dom";

export const getStringNthPosition = (string, subString, index) => {
  return string.split(subString, index).join(subString).length;
};

export const getContainerRoute = () => {
  const { location } = useHistory();
  const containerRoute = location.pathname.substring(
    0,
    getStringNthPosition(location.pathname, "/", 2)
  );
  return containerRoute;
};

export const getVideoCover = (file, seekTo = 0.0) => {
  console.log("getting video cover for file: ", file);
  return new Promise((resolve, reject) => {
    // load the file to a video player
    const videoPlayer = document.createElement("video");
    videoPlayer.setAttribute("src", URL.createObjectURL(file));
    videoPlayer.load();
    videoPlayer.addEventListener("error", (ex) => {
      reject(new Error("error when loading video file", ex));
    });
    // load metadata of the video to get video duration and dimensions
    videoPlayer.addEventListener("loadedmetadata", () => {
      // seek to user defined timestamp (in seconds) if possible
      if (videoPlayer.duration < seekTo) {
        reject(new Error("video is too short."));
        return;
      }
      // delay seeking or else 'seeked' event won't fire on Safari
      setTimeout(() => {
        videoPlayer.currentTime = seekTo;
      }, 200);
      // extract video thumbnail once seeking is complete
      videoPlayer.addEventListener("seeked", () => {
        console.log("video is now paused at %ss.", seekTo);
        // define a canvas to have the same dimension as the video
        const canvas = document.createElement("canvas");
        canvas.width = videoPlayer.videoWidth;
        canvas.height = videoPlayer.videoHeight;
        // draw the video frame to canvas
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
        // return the canvas image as a blob
        ctx.canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          "image/jpeg",
          0.75 /* quality */
        );
      });
    });
  });
};

const getUserGroups = (user) => {
  return user?.signInUserSession?.idToken?.payload["cognito:groups"];
};

export const isUserAdmin = (user) => {
  const userGroups = getUserGroups(user);
  return userGroups?.includes("AdminUsers");
};

export const isUserQM = (user) => {
  const userGroups = getUserGroups(user);
  return userGroups?.includes("QMUsers");
};
